import {useDispatch, useSelector} from "react-redux";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {rxUpdateToken} from "../../../slices/appSlice";
import {jwtDecode} from "jwt-decode";
import useFirebase from "../../../util/useFirebase";

const useSettingsAuthentication = () => {
  const dispatch = useDispatch();

  const {getAuth, GoogleAuthProvider, linkWithRedirect, ProviderId, unlink} = useFirebase();

  const token = useSelector(state => state.app.token);

  const {t} = useTranslation("settings_authentication");

  const dispatchTokenUpdate = useCallback(() => dispatch(rxUpdateToken({token: jwtDecode(getAuth().currentUser.accessToken)})), [dispatch, getAuth]);

  const linkGoogle = useCallback(() => {
    const googleAuthProvider = new GoogleAuthProvider();
    googleAuthProvider.setCustomParameters({login_hint: token.email});

    linkWithRedirect(getAuth().currentUser, googleAuthProvider).then(result => {
      const googleProviderData = result.user.providerData.find(pd => pd.providerId === ProviderId.GOOGLE);

      if (googleProviderData.email !== token.email) {
        unlink(getAuth().currentUser, ProviderId.GOOGLE)
          .then(() => dispatchTokenUpdate())
          .catch(console.error);
      } else {
        dispatchTokenUpdate();
      }
    }).catch(e => {
      console.error(e);
    });
  }, [token, dispatchTokenUpdate, getAuth, GoogleAuthProvider, linkWithRedirect, ProviderId, unlink]);

  const unlinkGoogleAccount = e => {
    e.preventDefault();

    return unlink(getAuth().currentUser, ProviderId.GOOGLE)
      .then(() => dispatchTokenUpdate())
      .catch(console.error);
  };

  return {
    t,
    token,
    linkGoogle,
    unlinkGoogleAccount,
    user: getAuth().currentUser
  };
};

export default useSettingsAuthentication;
